import { useRef } from 'react';

import { useLegalClientBeneficiarySavePep } from 'api/requests/onboarding/legal/beneficiary';
import { isGlobalProject } from 'config';
import { useServerErrorNotify } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { OnboardingPepConnectionFormType } from 'modules/onboarding/common/forms/onboardingPepConnectionForm';
import { getInitialData } from 'modules/onboarding/common/helpers/pepConnection/getInitialData';
import { getSubmitData } from 'modules/onboarding/common/helpers/pepConnection/getSubmitData';

import { useOnboardingContext } from './useOnboardingContext';

export const usePepConnection = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();
  const { t } = useTranslation();

  const {
    savePepConnection,
    loading: submitLoading,
    error,
  } = useLegalClientBeneficiarySavePep();

  const initialValues = useRef(
    getInitialData(data.legalClientBeneficiary.pepConnection, t)
  ).current;

  const onSubmit = async (values: OnboardingPepConnectionFormType) => {
    if (values) {
      const submitData = getSubmitData(values, {
        notRequestInformation: isGlobalProject(),
      });
      await savePepConnection(
        data.legalClient.id,
        data.legalClientBeneficiary.id,
        submitData
      );
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    onSubmit,
    goToBack,
    initialValues,
    submitLoading,
  };
};
